var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"saveby-icon"},[_c('i',{class:_vm.iconClass})]),_c('span',[_vm._v(_vm._s(_vm.row['saveBy']))])])
}
var staticRenderFns = []

export { render, staticRenderFns }